export const Prices_EN_Trans = {
    title: 'Prices',
    pricing: 'Pricing',
    choosePlan: 'Choose Your Subscription Plan',
    description: 'Select the perfect subscription plan for your food truck business needs. We offer flexible options to help you grow your business.',
    noMeals: 'No meal types available',
    needHelp: 'Need Help Choosing?',
    contactUs: 'Contact our team for personalized assistance in selecting the right plan for your business.',
    contactUsButton: 'Contact Us',
}

export const Prices_DE_Trans = {
    title: 'Preise',
    pricing: 'Preisgestaltung',
    choosePlan: 'Wählen Sie Ihren Abonnementplan',
    description: 'Wählen Sie den perfekten Abonnementplan für die Bedürfnisse Ihres Food-Truck-Unternehmens. Wir bieten flexible Optionen, um Ihnen beim Wachstum Ihres Unternehmens zu helfen.',
    noMeals: 'Keine Mahlzeitenarten verfügbar',
    needHelp: 'Brauchen Sie Hilfe bei der Auswahl?',
    contactUs: 'Kontaktieren Sie unser Team für persönliche Unterstützung bei der Auswahl des richtigen Plans für Ihr Unternehmen.',
    contactUsButton: 'Kontaktieren Sie uns',
};

